<template>
  <v-content id="userpages">
    <v-responsive :style="styles" min-height="100vh" class="d-flex align-center">
      <router-view />
    </v-responsive>
  </v-content>
</template>

<script>
export default {
  name: "UserPagesCoreView",

  computed: {
    styles() {
      const paddingTop = this.$vuetify.breakpoint.mdAndUp ? 175 : 100;
      const paddingBottom = this.$vuetify.breakpoint.mdAndUp ? 175 : 150;
      return {
        padding: `${paddingTop}px 0 ${paddingBottom}px 0`
      };
    }
  }
};
</script>
